import $ from 'jquery';

window.$ = window.jQuery = $;
window.$ = window.jQuery = $.noConflict();


export class Collapsible {
    constructor() {


        this.jquery();

        // this.common();
    }

    jquery() {
        $('.js-collapse').click(function (event) {

            let $this = $(this);
            let $target = $(`#${$this.data('target')}`);

            if (!$target) {
                return false;
            }

            if (!$this.hasClass('active')) {
                $this.addClass('active');
                $target.addClass('active');
                $target.show('active');
            } else {
                $this.removeClass('active');
                $target.removeClass('active');
                $target.hide('active');
            }

        });
    }

    common() {
        this.items = document.querySelectorAll('.js-collapse');

        if (this.items.length <= 0) {
            return false;
        }
        this.applyEvent();
    }

    applyEvent() {

        this.items.forEach(element => {
            element.addEventListener('click', function (event) {
                event.preventDefault();

                let self = event.target;

                let target = self.getAttribute('data-target');
                if (target.length <= 0) {
                    return false;
                }

                let targetElement = document.getElementById(target);
                if (targetElement.length <= 0) {
                    return false;
                }

                self.classList.toggle('active');
                targetElement.classList.toggle('active');

                if (targetElement.style.maxHeight) {
                    targetElement.style.maxHeight = null;
                } else {
                    targetElement.style.maxHeight = targetElement.scrollHeight + "px";
                }
            });
        });

    }
}